module.exports = __webpack_public_path__ + "media/images/auth/rectangles_l1-ecbe3e269e6e5755b7cb05d5b0498416.png";